/**
 * Static site data: external links, contact details, and the museum imagery.
 *
 * The museum photography is self-hosted from `public/images/` (`IMAGE_BASE`).
 */
export const IMAGE_BASE = '/images';

export const STORE_URL = 'https://cr7museumstore.com/';
export const FACEBOOK_URL = 'https://www.facebook.com/MuseuCr7/';
export const INSTAGRAM_URL = 'https://www.instagram.com/museucr7funchal/';
export const PHONE = '+351 291 639 880';
export const PHONE_HREF = 'tel:+351291639880';
export const MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Museu+CR7+Funchal';
export const MAP_EMBED = 'https://www.google.com/maps?q=Museu%20CR7%20Funchal%20Madeira&output=embed';
export const ADDRESS_LINES = [
  'Av. Sá Carneiro — Praça do Mar Nº27',
  'Funchal, 9004-518',
  'Madeira, Portugal',
];

export const LOGO = '/logo.svg';
export const VIRTUAL_IMG = `${IMAGE_BASE}/home/new_01.png`;
export const BANNER_IMG = `${IMAGE_BASE}/home/madeira_museum.jpg`;

/** Hero background slideshow (crossfades in this order). */
export const HERO_SLIDES = [
  'home/home_01.jpg',
  'home/home_02.jpg',
  'home/home_03.jpg',
].map((p) => `${IMAGE_BASE}/${p}`);

/** Achievements band. `key` indexes into the `stats` messages. */
export const STATS = [
  { value: '5', key: 'ballon' },
  { value: '5', key: 'ucl' },
  { value: '4', key: 'boots' },
  { value: '3', key: 'uefa' },
] as const;

/**
 * "A life in trophies" cards. `key` indexes into `museum.cards`; `delay` maps to
 * the `.d1`–`.d3` stagger classes so a row animates in sequence.
 */
export const MUSEUM_CARDS = [
  { key: 'boots', img: `${IMAGE_BASE}/home/experiences_01.jpg`, delay: 0 },
  { key: 'ballon', img: `${IMAGE_BASE}/home/experiences_02.jpg`, delay: 1 },
  { key: 'clubs', img: `${IMAGE_BASE}/home/experiences_03.jpg`, delay: 2 },
  { key: 'fans', img: `${IMAGE_BASE}/home/experiences_04.jpg`, delay: 1 },
  { key: 'ar', img: `${IMAGE_BASE}/home/experiences_06.jpg`, delay: 2 },
  { key: 'memorabilia', img: `${IMAGE_BASE}/memorabilia.jpg`, delay: 3 },
] as const;
